import { Controller } from "@hotwired/stimulus";

function csrfToken() {
  return (document.querySelector('meta[name="csrf-token"]') || {}).content || "";
}

export default class extends Controller {
  static values = { tenant: String };

  async switch(event) {
    const sceneName = event.params.name;
    try {
      const response = await fetch("/api/v1/obs/scene", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken(),
          Accept: "application/json",
        },
        body: JSON.stringify({ scene_name: sceneName, tenant_slug: this.tenantValue }),
      });
      if (!response.ok) console.error("[obs-scene] Switch failed");
    } catch (e) {
      console.error("[obs-scene]", e);
    }
  }
}
